import React from 'react';
import { translations } from '../../translations';
import './About.css';

const About = ({ language = 'en' }) => {
  const t = translations[language]?.about || translations.en.about;

  return (
    <section className="about" id="A">
      <div className="about__container">
        <div className="about__header">
          <h2 className="about__heading">{t.heading}</h2>
          <div className="about__divider"></div>
        </div>
        <div className="about__content">
          <div className="about__image">
            <img
              src="https://instacarspa.s3.us-east-1.amazonaws.com/14.jpg"
              alt={t.heading}
            />
          </div>
          <div className="about__text">
            <p>{t.text1}</p>
            <p>{t.text2}</p>
            <p>{t.text3}</p>
            <p>{t.text4}</p>
            <p>{t.text5}</p>
          
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
